import React from 'react'
import PropTypes from 'prop-types'
import { partial } from 'lodash-es'
import classnames from 'classnames'

import Upload from 'antd/lib/upload'
import 'antd/lib/upload/style/css'

import previewImageLoad from '../../utils/previewImageLoad'

import './UploadComponent.scss'

const { Dragger } = Upload

const handleRequest = (withPreviewImage, customRequest, file) => {
  if (withPreviewImage) {
    previewImageLoad(file, customRequest)
    return
  }

  customRequest(file)
}

const UploadComponent = (props) => {
  const {
    children,
    isDragAndDropAllowed,
    customRequest,
    withPreviewImage,
    isButtonBottomAligned,
    ...restProps
  } = props

  const Component = isDragAndDropAllowed ? Dragger : Upload

  return (
    <div
      className={classnames('upload-component antd-component', {
        'bottom-aligned-button': isButtonBottomAligned,
      })}
    >
      <Component
        {...restProps}
        customRequest={partial(handleRequest, withPreviewImage, customRequest)}
      >
        {children}
      </Component>
    </div>
  )
}

UploadComponent.propTypes = {
  children: PropTypes.node,
  listType: PropTypes.string,
  withPreviewImage: PropTypes.bool,
  customRequest: PropTypes.func,
  isButtonBottomAligned: PropTypes.bool,
  isDragAndDropAllowed: PropTypes.bool,
}

UploadComponent.defaultProps = {
  listType: 'text',
}

export default UploadComponent
